import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from '../hooks/useTranslation';

export default function VerifyEmail() {
  const { t, currentLanguage } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [status, setStatus] = useState<'working' | 'confirmed' | 'already_confirmed' | 'invalid' | 'sent' | 'failed'>(
    token ? 'working' : 'sent',
  );
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;
    axios.post('/api/verify-email', { token })
      .then((response) => setStatus(response.data.status === 'already_confirmed' ? 'already_confirmed' : 'confirmed'))
      .catch(() => setStatus('invalid'));
  }, [token]);

  const resend = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    try {
      await axios.post(`/api/verify-email/resend?lang=${currentLanguage}`, { email });
      setStatus('sent');
    } catch {
      setStatus('failed');
    } finally {
      setLoading(false);
    }
  };

  const heading = status === 'already_confirmed'
    ? t('email_verification.already_confirmed')
    : status === 'invalid'
      ? t('email_verification.invalid_link')
      : status === 'failed'
        ? t('email_verification.send_failed')
      : status === 'confirmed'
        ? t('email_verification.confirmed')
        : t('email_verification.sent');

  return (
    <div className="min-h-screen flex items-center justify-center py-8">
      <div className="w-full max-w-md mx-auto bg-gray-800/50 backdrop-blur-lg border border-gray-700 rounded-lg p-8 text-center">
        <h1 className="text-3xl font-bold text-white mb-4">{t('email_verification.title')}</h1>
        <p className="text-gray-300 mb-8">{heading}</p>
        {!token && (
          <form onSubmit={resend} className="space-y-4 text-left">
            <input
              type="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder={t('auth.email_placeholder')}
              className="w-full px-4 py-3 bg-gray-700/50 border border-gray-600 rounded-md text-white"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold py-3 rounded-md"
            >
              {t('email_verification.resend_button')}
            </button>
          </form>
        )}
        <Link to="/login" className="inline-block mt-6 text-purple-300 hover:text-white">
          {t('email_verification.go_to_login')}
        </Link>
      </div>
    </div>
  );
}
